import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { persistMiddleware } from './middleware/persist';
import rootReducer from './reducers';
const store = configureStore({
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([persistMiddleware]),
    preloadedState: undefined,
    reducer: rootReducer,
});
export const useAppDispatch = () => useDispatch();
export const useAppSelector = (selector) => useSelector(selector);
export default store;
